



















































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { ILoginRequest } from "@/types/login";
import { IUser, UserState } from "@/types/user";

@Component({
  components: {},
})
export default class extends Vue {
  @Action("login/login")
  public login!: (request: ILoginRequest) => boolean;
  // @Action("login/logout")
  // public logout!: () => boolean;
  @Action("auth/deauthorize")
  public deauthorize!: () => void;

  @Getter("login/redirectUrl")
  public redirectUrl!: string;
  @Getter("auth/isCompany")
  public isCompany!: boolean;
  @Getter("auth/isMember")
  public isMember!: boolean;
  @Getter("auth/isSale")
  public isSale!: boolean;
  @Getter("auth/me")
  public me!: IUser;
  @Getter("auth/getState")
  public getState!: () => UserState;

  @Mutation("login/clearRedirectUrl")
  public clearRedirectUrl!: () => void;

  public form: ILoginRequest = {
    email: "",
    password: "",
  };
  private async created() {
    await Promise.all([this.deauthorize(), this.clearRedirectUrl()]);
  }
  //--------
  // ログインボタン押下時
  public async loginClicked() {
    if (!(await this.login(this.form))) {
      return;
    }

    let routeName = "Home";
    if (this.isCompany) {
      routeName = "Company";
    } else if (this.isMember) {
      routeName = "Member";
    } else if (this.isSale) {
      routeName = "SalesDashboard";
    }

    let route: { name?: string; path?: string } = {
      name: routeName,
    };
    return this.$router.push(route);
  }
}
